module.exports = __webpack_public_path__ + "static/img/waThree.e7a3668.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/waThree.jpg
// module id = u8Sh
// module chunks = 1